import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'semantic-ui-react';
import { responseError } from '../../../helpers';
import FormEnterprisePermissions from '../company/enteprise-permissions/FormEnterprisePermissions';
import enterprisePermissionsDefault from '../company/enteprise-permissions/AllPermissions';
import { setSnackbar } from '../../../actions/snackbar.actions';
import { advisorAPI } from '../../../apis/AdvisorsAPI';

const UpdatePermissions = ({ refreshFunction, permissions, setPermissions }) => {
    const dispatch = useDispatch();
    const me = useSelector((state) => state.me);
    const advisorProfile = useSelector(state => state.currentAdvisorProfile);
    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleUpdate = async () => {
        setLoading(true)
        try {
            const auxPermissions = {};
            for (const per of enterprisePermissionsDefault) {
                if (!auxPermissions[per.key]) {
                auxPermissions[per.key] = {
                    fields: [],
                    isActive: false,
                };
                }
            }
            for (const per of permissions) {
                const [key, field] = per.split(':');
                if (auxPermissions[key]) {
                auxPermissions[key].isActive = true;
                auxPermissions[key].fields.push(field);
                } else {
                console.warn(`key not found => ${key}`)
                }
            }
            const {data} = await advisorAPI.put(`/${advisorProfile?._id}/enterprise-permissions`, auxPermissions);
            dispatch(setSnackbar({message: data.message || 'Success'}));
            refreshFunction()
        } catch (error) {
            responseError(error, undefined, "UpdatePermissions.handleUpdate", dispatch)
        }
        setLoading(false)
    }

    if (!me.permissions.includes("advisor:update_enterprise_permissions")) {
        return <div></div>;
    }

    return (
        <>
            <div>
                <Button color="green" onClick={() => setOpenModal(!openModal)} disabled={loading}>Update permissions</Button>
            </div>

            <Modal open={openModal}>
                <Modal.Header>Update Permissions for {advisorProfile?.fullName}</Modal.Header>
                <Modal.Content>
                    <div>
                    <FormEnterprisePermissions
                        permissions={permissions}
                        setPermissions={setPermissions}
                        defaultPermissions={enterprisePermissionsDefault}
                    />
                    </div>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={() => setOpenModal(false)}>Cancel</Button>
                    <Button onClick={() => handleUpdate()} color="green" loading={loading}>
                        Update Permissions
                    </Button>
                </Modal.Actions>
            </Modal>
        </>
    );
};

export default UpdatePermissions;
